{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            copyright (c) 2021                                      }
{            Email : info@tmssoftware.com                            }
{            Web : http://www.tmssoftware.com                        }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.TMSFNCWXMediaPlayer.Consts;

interface

const
  LB = #13;
  MESSAGEID = 'MessageID';
  MEDIAINITIALIZED = 'MEDIA_INIT';
  MESSAGEDATA = 'MessageData';
  CONTROL_ID = 'TTMSFNCWXHTMLMEDIAPLAYERID#';
  PLAYMEDIA = CONTROL_ID + '.play();';
  PAUSEMEDIA = CONTROL_ID + '.pause();';
  TOGGLEMUTE = CONTROL_ID + 'ToggleMute(%s)';
  TOGGLECONTROLS = CONTROL_ID + 'ToggleControls(%s)';
  TOGGLELOOP = CONTROL_ID + 'ToggleLoop(%s)';
  TOGGLEAUTOPLAY = CONTROL_ID + 'ToggleAutoPlay(%s)';
  MEDIASOURCE = CONTROL_ID + 'SetSource("%s")';
  MEDIARESTART = CONTROL_ID + 'PlayFrom(%s)';
  MEDIAFORWARD = CONTROL_ID + 'Forward(%s)';
  MEDIAREWIND = CONTROL_ID + 'Rewind(%s)';
  PRELOADMEDIA = CONTROL_ID + 'Preload("%s")';
  MEDIAVOLUME = CONTROL_ID + 'SetVolume(%s)';
  MEDIAPLAYBACKRATE = CONTROL_ID + 'SetPlayBackRate(%s)';

  ONMETADATALOAD = 'METADATALOADED';
  ONMEDIASTART = 'ONSTART';
  ONMEDIAPAUSE = 'ONPAUSE';
  ONMEDIAENDED = 'ONENDED';
  ONMEDIAERROR = 'ONERROR';
  ONMEDIARATECHANGE = 'ONRATECHANGE';
  ONMEDIAVOLUMECHANGE = 'ONVOLUMECHANGE';
  ONMEDIATIMEUPDATE = 'ONTIMEUPDATE';

  function GetWXMediaScript(AControlID: string): string;
  function GetWXInitializeMediaScript(AControlID, ADefaultEventDataObject:string): string;

implementation

function GetWXMediaScript(AControlID: string): string;
begin
  Result :=
    '  function ' + AControlID + 'ToggleMute(a){'+LB+
    '    document.getElementById("'+AControlID+'").muted = a;' + LB +
    '  };' + LB +
    '  function ' + AControlID + 'ToggleControls(a){'+LB+
    '    document.getElementById("'+AControlID+'").controls = a;' + LB +
    '  };' + LB +
    '  function ' + AControlID + 'ToggleAutoPlay(a){'+LB+
    '    document.getElementById("'+AControlID+'").autoplay = a;' + LB +
    '  };' + LB +
    '  function ' + AControlID + 'ToggleLoop(a){'+LB+
    '    document.getElementById("'+AControlID+'").loop = a;' + LB +
    '  };' + LB +
    '  function ' + AControlID + 'SetSource(a){'+LB+
    '    document.getElementById("'+AControlID+'").pause();' + LB +
    '    document.getElementById("'+AControlID+'").src = a;' + LB +
    '  };' + LB +
    '  function ' + AControlID + 'SetVolume(a){'+LB+
    '    document.getElementById("'+AControlID+'").volume = a;' + LB +
    '  };' + LB +
    '  function ' + AControlID + 'SetPlayBackRate(a){'+LB+
    '    document.getElementById("'+AControlID+'").playbackRate = a;' + LB +
    '  };' + LB +
    '  function ' + AControlID + 'PlayFrom(a){'+LB+
    '    document.getElementById("'+AControlID+'").currentTime = a;' + LB +
    '  };' + LB +
    '  function ' + AControlID + 'Forward(a){'+LB+
    '    document.getElementById("'+AControlID+'").currentTime += a;' + LB +
    '  };' + LB +
    '  function ' + AControlID + 'Rewind(a){'+LB+
    '    document.getElementById("'+AControlID+'").currentTime -= a;' + LB +
    '  };' + LB +
    '  function ' + AControlID + 'Preload(a){'+LB+
    '    document.getElementById("'+AControlID+'").preload = a;' + LB +
    '  };';
end;

function GetWXInitializeMediaScript(AControlID, ADefaultEventDataObject: string): string;
begin
  result :=
    '    e.onloadedmetadata = (event) => {' + LB +
    '      var o = ' + ADefaultEventDataObject + ';' + LB +
    '      o["EventName"] = "' + ONMETADATALOAD + '";' + LB +
    '      var customdata = 0;' + LB +
    '      if (e.duration !== Infinity) { customdata = e.duration };' + LB +
    '      var cd = encodeURIComponent(JSON.stringify(customdata))' + LB +
    '      ' + AControlID + 'sendObjectMessage(JSON.stringify(o), cd);' + LB +
    '    }' + LB +
    '    e.onplay = (event) => {' + LB +
    '      var o = ' + ADefaultEventDataObject + ';' + LB +
    '      o["EventName"] = "' + ONMEDIASTART + '";' + LB +
    '      ' + AControlID + 'sendObjectMessage(JSON.stringify(o));' + LB +
    '    }' + LB +
    '    e.onpause = (event) => {' + LB +
    '      var o = ' + ADefaultEventDataObject + ';' + LB +
    '      o["EventName"] = "' + ONMEDIAPAUSE + '";' + LB +
    '      ' + AControlID + 'sendObjectMessage(JSON.stringify(o));' + LB +
    '    }' + LB +
    '    e.onended = (event) => {' + LB +
    '      var o = ' + ADefaultEventDataObject + ';' + LB +
    '      o["EventName"] = "' + ONMEDIAENDED + '";' + LB +
    '      ' + AControlID + 'sendObjectMessage(JSON.stringify(o));' + LB +
    '    }' + LB +
    '    e.addEventListener("error",() => {' + LB +
    '      var o = ' + ADefaultEventDataObject + ';' + LB +
    '      o["EventName"] = "' + ONMEDIAERROR + '";' + LB +
    '      var customdata =  e.error.code;' + LB +
    '      var cd = encodeURIComponent(JSON.stringify(customdata))' + LB +
    '      ' + AControlID + 'sendObjectMessage(JSON.stringify(o), cd);' + LB +
    '    });' + LB +
    '    e.onratechange = (event) => {' + LB +
    '      var o = ' + ADefaultEventDataObject + ';' + LB +
    '      o["EventName"] = "' + ONMEDIARATECHANGE + '";' + LB +
    '      var customdata = e.playbackRate;' + LB +
    '      var cd = encodeURIComponent(JSON.stringify(customdata))' + LB +
    '      ' + AControlID + 'sendObjectMessage(JSON.stringify(o), cd);' + LB +
    '    }' + LB +
    '    e.onvolumechange = (event) => {' + LB +
    '      var o = ' + ADefaultEventDataObject + ';' + LB +
    '      o["EventName"] = "' + ONMEDIAVOLUMECHANGE + '";' + LB +
    '      var customdata = e.volume;' + LB +
    '      var cd = encodeURIComponent(JSON.stringify(customdata))' + LB +
    '      ' + AControlID + 'sendObjectMessage(JSON.stringify(o), cd);' + LB +
    '    }' + LB +
    '    e.ontimeupdate = (event) => {' + LB +
    '      var o = ' + ADefaultEventDataObject + ';' + LB +
    '      o["EventName"] = "' + ONMEDIATIMEUPDATE + '";' + LB +
    '      var customdata = e.currentTime;' + LB +
    '      var cd = encodeURIComponent(JSON.stringify(customdata))' + LB +
    '      ' + AControlID + 'sendObjectMessage(JSON.stringify(o), cd);' + LB +
    '    }';
end;

end.
